import StarterKit from '@tiptap/starter-kit'
import Placeholder from '@tiptap/extension-placeholder'
import Link from '@tiptap/extension-link'
import { Mention } from '@tiptap/extension-mention'
import { mergeAttributes } from '@tiptap/core'
import { ReactRenderer } from '@tiptap/react'
import clsx from 'clsx'
import { MentionEntityAttributeKey } from '../../../../containers/Comment/CommentEditor/lib/Converter'
import Mentions from '../../../../containers/Comment/CommentEditor/Mentions'
import tippy, { GetReferenceClientRect } from 'tippy.js'
import Auth from '../../../../../lib/commons/auth'
import { MentionType } from '../../../../../store/comments'

export const createEditorExtensions = (
  placeholder: string,
  getMentionData: (
    projectUuid: string | undefined,
    query: string
  ) => Promise<any[]>,
  getProjectMentionData: (
    projectUuid: string | undefined,
    query: string
  ) => any[],
  projectUuid?: string
) => [
  StarterKit.configure({
    heading: false,
    horizontalRule: false,
  }),
  Placeholder.configure({
    placeholder,
  }),
  Link.configure({
    openOnClick: false,
    HTMLAttributes: {
      class: 'custom-link',
    },
  }),
  Mention.extend({
    addAttributes() {
      return {
        ...this.parent?.(),
        [MentionEntityAttributeKey.mentionUuid]: {
          default: null,
        },
        [MentionEntityAttributeKey.mentionType]: {
          default: null,
        },
      }
    },
    renderHTML({ node, HTMLAttributes }) {
      const mentionUuid = node.attrs[MentionEntityAttributeKey.mentionUuid]
      const mentionType = node.attrs[MentionEntityAttributeKey.mentionType]
      const loginUser = Auth.getCurrentTenant()!.user!.uuid
      const loginMention =
        mentionUuid === loginUser || mentionType === MentionType.PROJECT_MEMBER
      const newAttrs = {
        class: clsx(
          'mention-base',
          !loginMention && 'mention',
          loginMention && 'mention-login-user'
        ),
      }
      return [
        'span',
        mergeAttributes(
          { 'data-type': this.name },
          this.options.HTMLAttributes,
          HTMLAttributes,
          newAttrs
        ),
        this.options.renderText({
          options: this.options,
          node,
        }),
      ]
    },
  }).configure({
    HTMLAttributes: {
      class: 'mention',
    },
    suggestion: {
      items: async ({ query }) => {
        const userMentions = await getMentionData(projectUuid, query)
        const projectMention = getProjectMentionData(projectUuid, query)
        const result = [...projectMention, ...userMentions]
        return result
      },
      render: () => {
        let reactRenderer
        let popup
        return {
          onStart: props => {
            reactRenderer = new ReactRenderer(Mentions, {
              props,
              editor: props.editor,
            })

            popup = tippy('body', {
              getReferenceClientRect:
                props.clientRect as GetReferenceClientRect,
              appendTo: () => document.body,
              content: reactRenderer.element,
              showOnCreate: true,
              interactive: true,
              trigger: 'manual',
              placement: 'top-start',
              theme: 'mentionList',
            })
          },
          onUpdate(props) {
            reactRenderer?.updateProps(props)

            if (popup?.length) {
              popup[0].setProps({
                getReferenceClientRect: props.clientRect,
              })
            }
          },
          onKeyDown(props) {
            return reactRenderer?.ref?.onKeyDown(props)
          },
          onExit() {
            if (popup?.length) {
              popup[0].destroy()
            }
            if (!!reactRenderer) {
              reactRenderer.destroy()
            }
          },
        }
      },
    },
  }),
]
